/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { get, isEmpty, map, split } from 'lodash';
import { ArrowBack } from '@material-ui/icons';
import './styles.scss';
import { cancelSoothePass, soothe_pass_cancellation_reasons } from '../Shared/Helpers';
import RadioOptions from '../Shared/RadioOptions';
import ErrorModal from '../Shared/ErrorModal';

const CancelMembership = ({ handleBack, client }) => {
  const [selectedReason, setSelectedReason] = useState(null);
  const [cancellationReasons, setCancellationReasons] = useState([]);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [error, setError] = useState('');
  const [showPreCancelView, setShowPreCancelView] = useState(false);
  const [showCancelSuccessView, setShowCancelSuccessView] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    if (isEmpty(cancellationReasons)) {
      soothe_pass_cancellation_reasons((resp) => {
        const reasons = resp?.data?.soothe_pass_cancellation_reasons || [];
        if (reasons.length > 0) {
          setCancellationReasons(reasons);
        }
      });
    }
  }, []);

  const handleCancelMembership = () => {
    if (selectedReason) {
      const clientId = get(client, 'user_id', '');
      const { soothe_pass_subscription_id } = get(client, 'soothe_pass', {});
      // Assuming cancelSoothePass is a function that handles the cancellation
      cancelSoothePass(clientId, soothe_pass_subscription_id, selectedReason, (resp) => {
        const { result, message } = resp.data;
        if (result) {
          setSuccessMessage(message);
          setShowCancelSuccessView(true);
          // "message": "Your membership will end on Nov 21, 2024 and you will no longer be charged.\n\nIf you have any unused points, they will remain on your account, but you cannot use them once your membership ends.\n\nYou can rejoin anytime to access your points."
        }
      }, (err) => {
        const message = get(err, 'response.data.errors.0.message', 'An error occurred while cancelling your membership.');
        // Handle error
        setShowErrorModal(true);
        setError(message);
      });
    }
  };
  const optionsList = useMemo(() => {
    return map(cancellationReasons, (reason) => ({
      label: reason.reason,
      value: reason.id,
      checked: selectedReason === reason.id,
    }));
  }, [cancellationReasons, selectedReason]);
  // Need checked state to be managed by RadioOptions component
  // + styling

  const reasonsView = () => {
    return (
      <div className="cancel-membership-redesign">
        <div className="header-section">
          <div className="header-row">
            <button className="back-button" onClick={handleBack} type="button">
              <ArrowBack />
            </button>
            <h1 className="header-title">Share your reason for cancelling SoothePass™</h1>
          </div>
        </div>
        
        <div className="content-section">
          <div className="reasons-list">
            <RadioOptions
              name="cancellation-reasons"
              optionsArray={optionsList}
              onChange={(v) => { setSelectedReason(Number(v)); }}
            />
          </div>
        </div>
        
        <div className="footer-actions">
          <div className="actions-container">
            <button className="tertiary-button" type="button" onClick={handleBack}>
              Keep SoothePass™
            </button>
            <button 
              className="btn cta-primary p-10-12-imp"
              type="button"
              onClick={() => setShowPreCancelView(true)}
              disabled={!selectedReason}
              style={{ width: "auto" }}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    );
  }
  const preCancelView = () => {
    return (
      <div className="cancel-membership-redesign">
        <div className="header-section">
          <div className="header-row" style={{ display: "block" }}>
            <button className="back-button" onClick={() => setShowPreCancelView(false)} type="button">
              <ArrowBack />
            </button>
            <h1 className="header-title">You're about to cancel your SoothePass™ membership</h1>
          </div>
        </div>
        
        <div className="content-section">
          <div className="confirmation-content">
            <p className="warning-text">
              If you cancel your membership, your unused points will remain on your account until they expire and disappear on: {get(client, 'soothe_pass.subscription_next_charge_date_only', 'June 31, 2022')}.
              <br /><br />
              Rejoining SoothePass will not bring back any expired points.
            </p>
            
            <div className="benefits-box">
              <p className="benefits-title">You'll miss out on these membership benefits:</p>
              <div className="benefits-list">
                <ul>
                  <li>Up to 30% off all services with members-only pricing</li>
                  <li>Ability to use points to redeem from over 40 services</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-actions">
          <div className="actions-container">
            <button className="tertiary-button" type="button" onClick={handleBack}>
              Keep SoothePass™
            </button>
            <button 
              className="btn danger-btn p-10-12-imp"
              type="button"
              onClick={() => handleCancelMembership()}
            >
              Cancel SoothePass™
            </button>
          </div>
        </div>
      </div>
    );
  };

  const cancelSuccessView = () => {
    const messages = split(successMessage, '\n\n');

    return (
      <div className="pause-membership-container-redesign contentPrimary">
        <div className="back-button" onClick={() => handleBack(true)} role="button" tabIndex={0} onKeyDown={() => handleBack(true)}>
          <ArrowBack />
        </div>
        <div className="size-24-32 font-weight-bold mb-24">We're sorry to see you go</div>
        <div className="mb-16">
          {map(messages, (message, index) => (
            <div key={index} className="mb-16">{message}
              {index < messages.length - 1 ? <><br /><br /></> : null}
            </div>
          ))}
        </div>
        {/* <CTAButton
          text="Done"
          action={handleBack}
          additionalClass="resp-w-303 size-14-16-imp p-10-12-imp"
          additionalWrapperClass="justify-content-center"
        /> */}
        <button type='button' className='btn md-cta-primary p-10-12-imp'
          onClick={() => handleBack(true)}
          style={{ width: "auto" }}
        >Done</button>
      </div>
    );
  };

  return (<>
    {showCancelSuccessView ? cancelSuccessView() : showPreCancelView ? preCancelView() : reasonsView()}
    <ErrorModal
      isOpen={showErrorModal}
      close={() => setShowErrorModal(false)}
    >
      {error}
    </ErrorModal>
  </>
  );
};

const mapStateToProps = (state) => ({
  client: state.client,
  translate: get(state, 'localize.translate'),
});

export default connect(mapStateToProps)(CancelMembership); 